import React, { useEffect, useState } from "react";
import { getVocationalSchedule } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

// Lịch học nghề chi tiết của 1 tuần TKB (import từ sheet "Học nghề chi tiết").
const HappySchoolTKBNghe = ({ weekId }) => {
  const schoolId = getActiveSchoolId();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => {
    if (!schoolId || !weekId) return;
    setLoading(true);
    getVocationalSchedule(schoolId, weekId)
      .then((data) => setRows(Array.isArray(data.rows) ? data.rows : []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [schoolId, weekId]);

  if (!weekId) return <p style={{ color: "#6b7280" }}>Chưa chọn tuần TKB.</p>;
  if (loading) return <p>Đang tải...</p>;
  if (error) return <p style={{ color: "#dc2626" }}>{error}</p>;
  if (rows.length === 0) return <p style={{ color: "#6b7280" }}>Chưa có dữ liệu học nghề cho tuần này.</p>;

  const kw = q.trim().toLowerCase();
  const filtered = kw
    ? rows.filter((r) =>
        [r.className, r.ngheClass, r.subject, r.teacher, r.room, r.day].some((v) => String(v || "").toLowerCase().includes(kw))
      )
    : rows;

  return (
    <div>
      <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 10, flexWrap: "wrap" }}>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Tìm lớp / môn / giáo viên / phòng..."
          style={{ padding: 8, minWidth: 260, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 13 }} />
        <span style={{ fontSize: 12, color: "#6b7280" }}>{filtered.length}/{rows.length} buổi học nghề</span>
      </div>
      <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
        <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
          <thead>
            <tr>
              <th style={thStyle}>STT</th>
              <th style={{ ...thStyle, textAlign: "left" }}>Lớp</th>
              <th style={{ ...thStyle, textAlign: "left" }}>Tên lớp nghề</th>
              <th style={{ ...thStyle, textAlign: "left" }}>Môn học</th>
              <th style={{ ...thStyle, textAlign: "left" }}>Ngày học</th>
              <th style={{ ...thStyle, textAlign: "left" }}>Phòng</th>
              <th style={{ ...thStyle, textAlign: "left" }}>Giáo viên</th>
              <th style={{ ...thStyle, textAlign: "left" }}>Ghi chú</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r, i) => (
              <tr key={i} style={{ background: i % 2 ? "#fafafa" : "#fff" }}>
                <td style={{ ...tdStyle, textAlign: "center", color: "#6b7280" }}>{r.stt}</td>
                <td style={{ ...tdStyle, fontWeight: 600 }}>{r.className}</td>
                <td style={tdStyle}>{r.ngheClass}</td>
                <td style={tdStyle}>{r.subject}</td>
                <td style={{ ...tdStyle, whiteSpace: "nowrap" }}>{r.day}</td>
                <td style={tdStyle}>{r.room}</td>
                <td style={{ ...tdStyle, whiteSpace: "nowrap" }}>{r.teacher}</td>
                <td style={{ ...tdStyle, color: "#6b7280" }}>{r.note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const thStyle = { border: "1px solid #e5e7eb", padding: "6px 10px", background: "#f9fafb", whiteSpace: "nowrap", position: "sticky", top: 0 };
const tdStyle = { border: "1px solid #e5e7eb", padding: "6px 10px", textAlign: "left" };

export default HappySchoolTKBNghe;
